import {
  ChangeAdvokatselskabKind,
  ChangeInteressentskabKind,
  InterestPartyChangeDirection,
} from "../model/registrationEnums";
import type { InterestPartyChangeDirection as InterestPartyChangeDirectionType } from "../model/registrationEnums";

export const isEntersInterestParty = (
  changeKind: string,
  direction: InterestPartyChangeDirectionType,
): boolean =>
  changeKind === ChangeInteressentskabKind.InteressentInd ||
  (changeKind === ChangeInteressentskabKind.InteressentBegge &&
    direction === InterestPartyChangeDirection.Enters);

export const isEntersAdvokatselskabPartner = (
  changeKind: string,
  direction: InterestPartyChangeDirectionType,
): boolean =>
  changeKind === ChangeAdvokatselskabKind.PartnerInd ||
  (changeKind === ChangeAdvokatselskabKind.PartnerBegge &&
    direction === InterestPartyChangeDirection.Enters);

export const isLeavesInterestParty = (
  changeKind: string,
  direction: InterestPartyChangeDirectionType,
): boolean =>
  changeKind === ChangeInteressentskabKind.InteressentUd ||
  (changeKind === ChangeInteressentskabKind.InteressentBegge &&
    direction === InterestPartyChangeDirection.Leaves);

export const isLeavesAdvokatselskabPartner = (
  changeKind: string,
  direction: InterestPartyChangeDirectionType,
): boolean =>
  changeKind === ChangeAdvokatselskabKind.PartnerUd ||
  (changeKind === ChangeAdvokatselskabKind.PartnerBegge &&
    direction === InterestPartyChangeDirection.Leaves);
